package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Macao Flag (20x15dp)
 *
 * - ISO Alpha-2: MO
 * - ISO Alpha-3: MAC
 * - ISO Numeric: 446
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Macao: ImageVector by lazy {
    ImageVector.Builder(
        name = "Macao:MO:MAC:446:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF1C9975)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.014f, 4.284f)
                lineTo(8.992f, 4.9f)
                lineTo(9.225f, 3.697f)
                lineTo(8.375f, 2.797f)
                lineTo(9.526f, 2.748f)
                lineTo(10.014f, 1.625f)
                lineTo(10.501f, 2.748f)
                horizontalLineTo(11.65f)
                lineTo(10.802f, 3.697f)
                lineTo(11.057f, 4.9f)
                lineTo(10.014f, 4.284f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.114f, 4.74f)
                lineTo(6.483f, 5.121f)
                lineTo(6.627f, 4.378f)
                lineTo(6.101f, 3.821f)
                lineTo(6.813f, 3.791f)
                lineTo(7.114f, 3.096f)
                lineTo(7.415f, 3.791f)
                horizontalLineTo(8.126f)
                lineTo(7.601f, 4.378f)
                lineTo(7.759f, 5.121f)
                lineTo(7.114f, 4.74f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.863f, 4.74f)
                lineTo(12.232f, 5.121f)
                lineTo(12.376f, 4.378f)
                lineTo(11.85f, 3.821f)
                lineTo(12.562f, 3.791f)
                lineTo(12.863f, 3.096f)
                lineTo(13.164f, 3.791f)
                horizontalLineTo(13.875f)
                lineTo(13.351f, 4.378f)
                lineTo(13.508f, 5.121f)
                lineTo(12.863f, 4.74f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.479f, 6.007f)
                lineTo(4.972f, 6.313f)
                lineTo(5.088f, 5.716f)
                lineTo(4.666f, 5.269f)
                lineTo(5.237f, 5.245f)
                lineTo(5.479f, 4.688f)
                lineTo(5.721f, 5.245f)
                horizontalLineTo(6.291f)
                lineTo(5.87f, 5.716f)
                lineTo(5.997f, 6.313f)
                lineTo(5.479f, 6.007f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.726f, 6.007f)
                lineTo(14.219f, 6.313f)
                lineTo(14.334f, 5.716f)
                lineTo(13.913f, 5.269f)
                lineTo(14.484f, 5.245f)
                lineTo(14.726f, 4.688f)
                lineTo(14.967f, 5.245f)
                horizontalLineTo(15.538f)
                lineTo(15.117f, 5.716f)
                lineTo(15.243f, 6.313f)
                lineTo(14.726f, 6.007f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(10f, 13.75f)
                curveTo(12.761f, 13.75f, 15f, 11.511f, 15f, 8.75f)
                curveTo(15f, 5.989f, 12.761f, 3.75f, 10f, 3.75f)
                curveTo(7.239f, 3.75f, 5f, 5.989f, 5f, 8.75f)
                curveTo(5f, 11.511f, 7.239f, 13.75f, 10f, 13.75f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.926f, 13.165f)
                horizontalLineTo(12.075f)
                verticalLineTo(13.835f)
                horizontalLineTo(7.926f)
                verticalLineTo(13.165f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.223f, 12.163f)
                horizontalLineTo(14.202f)
                verticalLineTo(12.777f)
                horizontalLineTo(6.223f)
                verticalLineTo(12.163f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(7.888f, 11.888f)
                horizontalLineTo(5.447f)
                verticalLineTo(11.263f)
                lineTo(7.883f, 11.263f)
                curveTo(8.746f, 11.251f, 9.377f, 11.004f, 9.798f, 10.53f)
                lineTo(10.007f, 10.294f)
                lineTo(10.241f, 10.506f)
                curveTo(10.803f, 11.016f, 11.364f, 11.263f, 11.932f, 11.263f)
                horizontalLineTo(14.622f)
                verticalLineTo(11.888f)
                horizontalLineTo(11.932f)
                curveTo(11.28f, 11.888f, 10.65f, 11.642f, 10.048f, 11.162f)
                curveTo(9.515f, 11.635f, 8.79f, 11.875f, 7.888f, 11.888f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFFF7FCFF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(10.022f, 4.755f)
            curveTo(10.022f, 4.755f, 8.954f, 5.81f, 8.954f, 7.258f)
            curveTo(8.954f, 7.568f, 9.003f, 7.86f, 9.08f, 8.129f)
            curveTo(8.735f, 7.366f, 8.712f, 6.54f, 9.009f, 5.638f)
            lineTo(8.604f, 5.504f)
            curveTo(8.302f, 6.422f, 8.301f, 7.285f, 8.601f, 8.084f)
            curveTo(7.98f, 7.71f, 7.267f, 7.459f, 6.534f, 7.378f)
            lineTo(6.487f, 7.801f)
            curveTo(7.128f, 7.872f, 7.753f, 8.086f, 8.301f, 8.402f)
            curveTo(8.166f, 8.347f, 8.024f, 8.299f, 7.876f, 8.262f)
            curveTo(6.524f, 7.917f, 5.197f, 8.406f, 5.197f, 8.406f)
            curveTo(5.197f, 8.406f, 5.962f, 10.122f, 7.444f, 10.375f)
            curveTo(7.518f, 10.388f, 7.591f, 10.398f, 7.663f, 10.405f)
            lineTo(7.652f, 10.405f)
            curveTo(6.946f, 10.405f, 6.289f, 10.116f, 5.673f, 9.529f)
            lineTo(5.38f, 9.837f)
            curveTo(6.071f, 10.497f, 6.831f, 10.831f, 7.652f, 10.831f)
            curveTo(8.455f, 10.831f, 9.201f, 10.511f, 9.883f, 9.88f)
            curveTo(9.992f, 9.814f, 10.056f, 9.767f, 10.067f, 9.759f)
            lineTo(10.093f, 9.782f)
            curveTo(10.079f, 9.806f, 10.072f, 9.82f, 10.072f, 9.82f)
            curveTo(10.072f, 9.82f, 10.139f, 9.86f, 10.261f, 9.917f)
            curveTo(10.934f, 10.439f, 11.776f, 10.831f, 12.442f, 10.831f)
            curveTo(13.264f, 10.831f, 14.024f, 10.497f, 14.715f, 9.837f)
            lineTo(14.421f, 9.529f)
            curveTo(13.806f, 10.116f, 13.149f, 10.405f, 12.442f, 10.405f)
            curveTo(12.184f, 10.405f, 11.931f, 10.364f, 11.683f, 10.28f)
            curveTo(12.031f, 10.299f, 12.413f, 10.268f, 12.809f, 10.146f)
            curveTo(14.269f, 9.7f, 14.877f, 8.35f, 14.877f, 8.35f)
            curveTo(14.877f, 8.35f, 14.101f, 7.931f, 13.114f, 7.927f)
            curveTo(13.335f, 7.87f, 13.566f, 7.828f, 13.807f, 7.801f)
            lineTo(13.76f, 7.378f)
            curveTo(12.835f, 7.481f, 12.034f, 7.793f, 11.363f, 8.314f)
            curveTo(11.755f, 7.451f, 11.786f, 6.511f, 11.455f, 5.504f)
            lineTo(11.05f, 5.638f)
            curveTo(11.321f, 6.46f, 11.325f, 7.219f, 11.063f, 7.925f)
            curveTo(11.108f, 7.716f, 11.135f, 7.493f, 11.135f, 7.258f)
            curveTo(11.135f, 5.731f, 10.022f, 4.755f, 10.022f, 4.755f)
            close()
            moveTo(10.491f, 9.222f)
            lineTo(10.476f, 9.245f)
            lineTo(10.495f, 9.222f)
            lineTo(10.491f, 9.222f)
            close()
            moveTo(9.459f, 9.122f)
            lineTo(9.501f, 9.084f)
            curveTo(9.539f, 9.147f, 9.577f, 9.207f, 9.614f, 9.262f)
            curveTo(9.566f, 9.217f, 9.514f, 9.17f, 9.459f, 9.122f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun MacaoPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Macao,
            contentDescription = "Macao Flag"
        )
    }
}
